import React, { useContext, useEffect, useState } from 'react'

type AddToHomeScreenContext = {
    deferredPrompt?: {
        prompt?(): void
        userChoice: Promise<{ outcome: 'dismissed' | 'accepted', platform: string }>
    }
    isAppInstallable?: boolean
    isAppInstalled?: boolean
}

const ADD_TO_HOME_SCREEN_CONTEXT = React.createContext<AddToHomeScreenContext>({})

export function useAddToHomeScreen() {
    return useContext(ADD_TO_HOME_SCREEN_CONTEXT)
}

type Props = {
    children: React.ReactNode
}

export function AddToHomeScreenProvider({ children }: Props) {
    const [state, setA2HPState] = useState<AddToHomeScreenContext>({})

    useEffect(() => {
        window.addEventListener('beforeinstallprompt', (e: any) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            //e.preventDefault()
            // Stash the event so it can be triggered later.
            setA2HPState({ deferredPrompt: e, isAppInstallable: true })
        })

        window.addEventListener('appinstalled', (evt) => {
            setA2HPState({ isAppInstalled: true })
        })
    }, [setA2HPState])

    return (
        <ADD_TO_HOME_SCREEN_CONTEXT.Provider value={state}>
            {children}
        </ADD_TO_HOME_SCREEN_CONTEXT.Provider>
    )
}
